module.exports = __webpack_public_path__ + "img/cloud.e4df2571.svg";